import React from "react";

const HomologacionExterna = () => {
  return (
    <div className="card-container">
      <header className="card-header">
        <h2>Homologación externa</h2>
        <p className="subtitle">
          Convalida <strong>sin costo</strong> tus materias aprobadas en{" "}
          <strong>otras instituciones</strong> y avanza hacia tu título de{" "}
          <strong>grado, posgrado o tecnología</strong> en la UTPL, una
          universidad líder en innovación y excelencia académica.
        </p>
      </header>

      <section className="card-body">
     

        <div className="process-section">
          <h3>Requisitos necesarios:</h3>
          <ul className="requirements-list">
            <li>
              Récord académico original emitido por la universidad de origen que
              indique:
              <ul className="sub-list">
                <li>Sistema de Calificación.</li>
                <li>Calificaciones obtenidas.</li>
                <li>Fecha y año de aprobación de cada asignatura.</li>
                <li>
                  Valoración en créditos y equivalencia en horas asistidas por
                  el docente, el práctico y autónomo de cada componente.
                </li>
                <li>
                  Programa formativo y plan de contenidos de cada componente.
                </li>
              </ul>
            </li>
            <li>Copia de cédula de identidad o pasaporte.</li>
          </ul>
          
        </div>

        <div className="alert-box special-note margin">
          <h4>Importante:</h4>
          <p>
            Tanto el récord académico como el programa formativo y plan de
            contenidos, deberán estar certificados por la institución.
          </p>
          <p>
            En el caso de estudios realizados en el exterior cuyos certificados
            estén en un idioma diferente al español, deberán presentarse la
            respectiva traducción legalizada o apostillada.
          </p>
          <p>
            Para la carrera de medicina se debe presentar una certificación de no haber
            recibido ninguna sanción disciplinaria en la universidad o escuela
            politécnica de origen.
          </p>
        </div>
   <div className="button-group">
          <button
            className="btn-primary"
            onClick={() => (window.location.href = "https://matriculas.utpl.edu.ec/")}
          >
            1. Crear credenciales
          </button>
          <button
            className="btn-primary"
            onClick={() => (window.location.href = "https://studentssb-prod.srv.utpl.edu.ec/StudentSelfService")}
          >
            2. Solicitar homologación
          </button>
        </div>
        <div className="process-section">
          <h3>Proceso de solicitud:</h3>
          <ol className="process-list numbered-steps">
            <li>
              <strong>Crear credenciales institucionales</strong>
              <ul className="sub-step-list">
                <li>
                  Haz clic en <strong>Crear credenciales</strong>, registra tus
                  datos personales o accede a través de las opciones disponibles
                  con Google o Facebook.
                </li>
                <li>
                  Haz clic en el apartado <strong>Matrícula</strong> y
                  selecciona la opción <strong>Nueva</strong>. Luego elige tu
                  carrera de interés y el centro universitario más cercano al
                  que perteneces. Selecciona la opción de matrícula Ciclo
                  completo.
                </li>
                <li>
                  Si aún no has registrado tus datos de identificación,
                  ingrésalos ubicando tu cédula de identidad o pasaporte. A
                  continuación, selecciona <strong>Siguiente</strong>.
                </li>
                <li>
                  No debes realizar el pago de la matrícula. Las credenciales
                  llegarán a tu correo electrónico.
                </li>
              </ul>
            </li>
            <li>
              <strong>Solicitud de homologación</strong>
              <ul className="sub-step-list">
                <li>
                  Haz clic en <strong>Solicitar homologación</strong> e ingresa
                  con tus credenciales institucionales.
                </li>
                <li>
                  Dirígete a <strong>Solicitud de Servicios</strong>, selecciona{" "}
                  <strong>Servicios-Reconocimiento de estudios</strong> y elige
                  la opción:{" "}
                  <strong>
                    Solicitar reconocimiento de estudios externos (grado y
                    posgrado)
                  </strong>
                  .
                </li>
                <li>
                  Selecciona tu carrera y en detalle de requerimiento escribe{" "}
                  <em>Solicito homologación a la carrera de…</em>
                </li>
                <li>
                  Carga tu documentación. Ten presente que toda la documentación
                  debe estar integrada en un único archivo en formato PDF. Si tu
                  archivo supera el peso indicado puedes adjuntar un enlace
                  hacía un repositorio externo.
                </li>
              </ul>
            </li>
          </ol>
        </div>

        <div className="info-grid dual-info">
          <div className="info-item">
            <span className="label">Costo del servicio:</span>
            <span className="value">Gratuito</span>
          </div>
       
        </div>

        <p className="status-note additional-info">
          Consulta el estado de la solicitud en el sistema institucional,
          apartado <strong>Ver status de la solicitud de servicio</strong>.
        </p>
        <p className="status-note additional-info">
          Recibirás un informe de las materias homologadas y luego podrás
          matricularte en las asignaturas correspondientes.
        </p>
      </section>

      <footer className="card-footer">
        <h4>¿Necesitas más información?</h4>
        <p>Solicita asesoría virtual en:</p>
        <div className="contact-links">
          <a href="https://utpl.edu.ec/zoom" target="_blank" rel="noreferrer">
            utpl.edu.ec/zoom
          </a>
          <a href="https://wa.me/593999565400" target="_blank" rel="noreferrer">
            WhatsApp: 0999565400
          </a>
        </div>
      </footer>
    </div>
  );
};

export default HomologacionExterna;
